import React, { useEffect, useState } from 'react';
import './DepartmentPopup.css'; // Optional for styling
import { getAllDocumentDepartments } from '../../../shared/services/railDocumentsApi';
import { DocumentDepartment } from '../../../shared/models/api/models';
import { getUserProfile, setDepartment } from '../../../shared/services/userApi';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

import {
    Label,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import useSelector from '../../../hooks/useSelector';
import { applicationState } from '../../../shared/store/applicationState';

const AddEditUserDepartment = () => {let profileInfo = useSelector(state => state.profile);
    const [showPopUp, setShowPopUp] = useState(false);
    const [departments, setDepartments] = useState([] as DocumentDepartment[]);
    const [isOpen, setIsOpen] = useState(true); // Set this based on your condition
    const [isOptional, setIsOptional] = useState(false); // Set this based on your condition
    const [selectedAnswer, setSelectedAnswer] = useState({} as DocumentDepartment);

    const userDepId = profileInfo?.userDepId ?? 0;
    const userDepName = profileInfo?.userDepName;

    const handleSave = () => {
        const mount = async () => {
            if (selectedAnswer.id) {
                await setDepartment(selectedAnswer.id);
                setIsOpen(false);
                setIsOptional(false);
                profileInfo = await getUserProfile();
                applicationState.setProfile(profileInfo);
            }
            else {
                setIsOptional(true);
            }
        }
        mount();
    };

    const handleSkip = () => {
        const mount = async () => {
            await setDepartment(userDepId);
            setIsOpen(false);
            profileInfo = await getUserProfile();
            applicationState.setProfile(profileInfo);
        }
        mount();
    };

    const answerSelected = (choice: DocumentDepartment) => {
        setSelectedAnswer(choice);
    }

    useEffect(() => {
        let mounted = true;

        if (profileInfo?.depIdModifiedDate) {
            let slightOverdueThreshold = 24 * 60 * 60000; //24 hr
            const currentDate = new Date;
            const depIdModifiedDate = new Date(profileInfo?.depIdModifiedDate);
            const diffTime = (currentDate.getTime() - depIdModifiedDate.getTime());
            console.log(diffTime);
            const diffDays = Math.ceil(diffTime / slightOverdueThreshold);
            if (diffDays > 20) { // 3 weeks = 21 days
                setShowPopUp(true);
            }
        }
        const getallDocumentDepartment = async () => {
            const results = await getAllDocumentDepartments();
            if (mounted && results) {

                setDepartments(results);
                if (userDepId != 0) {
                    { userDepName }
                }
            }
        };
        getallDocumentDepartment();

        if ((profileInfo !== undefined && profileInfo?.depIdModifiedDate == null)) {
            setShowPopUp(true);
        }
        return () => { mounted = false };
    }, [profileInfo]);

    if (!isOpen) return null;

    if (showPopUp) {
        return (
            <div className="popup-overlay">
                <div className="popup-box">
                    <div className="secondary-card-heading pb-1 alternate-text">Department</div>
                    {userDepId == 0 ?
                        <p>Your parent department is currently not set in Rail Portal. Please select your main department</p>
                        : <p>Your parent department is currently {userDepName}. If this has changed, please select and update your department below.</p>
                    }

                    <div>
                        <div className={`main-form-selector`}>
                            <UncontrolledDropdown className="dropdown-textalign">
                                <DropdownToggle
                                    className="form-control popup-box-dropdown popup-padding"
                                   tag="div" >
                                        <div className="fa-select-options">
                                            {selectedAnswer.name ? selectedAnswer.name : <span className="fa-select-default">Please Select Department</span>}
                                        </div>
                                        <div className="fa-select-button" >
                                            <ExpandMore className="expanded-show" />
                                            <ExpandLess className="expanded-hide" />
                                        </div>
                                </DropdownToggle>
                                <DropdownMenu className="popup-box-dropdown ">
                                    {departments.map((choice) => (
                                        <DropdownItem
                                            key={choice.id}
                                            className={`form-check-inline popup-box-dropdownselect dropdown-item ${choice.id}`}
                                            onClick={() => answerSelected(choice)}>
                                            <Label className={`form-check-label`} >{choice.name}</Label>
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            <span className={`${isOptional ? "d-block" : ""}`}> {isOptional ? "Required" : ""}</span>
                        </div>
                    </div>
                    <div>
                        {userDepId != 0 ? <button className="btn-primary pr-4 pl-4 m-4" onClick={handleSkip}>Skip</button> : ""}
                        <button className="btn-primary pr-4 pl-4 m-4" onClick={handleSave}> {userDepId == 0 ? 'Save' : 'Update'}</button>
                    </div>
                </div>
                </div>
        );
    }
    return null;
    //}
    //return null;
};

export default AddEditUserDepartment;

